import axios from "../components/shared/axios";

const baseURL = process.env.REACT_APP_BACKEND_URL;

export const getFeedbackTemplate = async (id) => {
  const params = { feedbackSkeletonId: id };
  return await axios.get(`${baseURL}/feedback-skeleton`, { params });
};
